import { BaseCartridge, RomImage } from './base';

/**
 * Mapper 3 — CNROM. NROM-style fixed PRG; 8KB CHR bank select at 0x8000+.
 */
export class CnromCartridge extends BaseCartridge {
    private chrBank = 0;

    constructor(image: RomImage) {
        super(image);
    }

    cpuRead(address: number): number {
        const ram = { value: 0 };
        if (this.readPrgRam(address, ram)) return ram.value;
        if (address >= 0x8000) {
            return this.prgRom[(address - 0x8000) % this.prgRom.length];
        }
        return 0;
    }

    cpuWrite(address: number, value: number): void {
        if (this.writePrgRam(address, value)) return;
        if (address >= 0x8000) {
            this.chrBank = value & 0x03;
        }
    }

    private chrOffset(address: number): number {
        const banks8 = Math.max(1, this.chr.length / 0x2000);
        return ((this.chrBank % banks8) * 0x2000 + (address & 0x1FFF)) % this.chr.length;
    }

    ppuRead(address: number): number {
        return this.chr[this.chrOffset(address)];
    }

    ppuWrite(address: number, value: number): void {
        if (this.chrIsRam) {
            this.chr[this.chrOffset(address)] = value & 0xFF;
        }
    }
}
